module.exports = __webpack_public_path__ + "img/msu3-char-2.858e7175.png";